export default __webpack_public_path__ + "static/media/CapaWelcomeMobile.f002f88e.png";